import { render, staticRenderFns } from "./DealList.vue?vue&type=template&id=3f8373e3&"
import script from "./DealList.vue?vue&type=script&lang=ts&"
export * from "./DealList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports